import { Box, Modal } from "@mui/material";
import useUser from "hooks/useUser";
import { useEffect, useState } from "react";
import TermsTabs from "./TermsTabs";

const TermsModal = ({ children }) => {
  const userData = useUser();

  const [open, setOpen] = useState(false);
  const handleClose = (_, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") return;
    setOpen(false);
  };

  useEffect(() => {
    if (userData?.isTermsApprovalRequired) setOpen(true);
  }, [userData?.isTermsApprovalRequired]);

  return (
    <>
      {children}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-terms-conditions"
        sx={(theme) => ({
          color: "white",
          zIndex: theme.zIndex.drawer + 1,
        })}
      >
        <Box>
          <TermsTabs handleClose={handleClose} />
        </Box>
      </Modal>
    </>
  );
};

export default TermsModal;
